module.exports = __webpack_public_path__ + "img/trunk_3x4.ac5fbc7f.svg";